export const locale = {
  lang: 'en',
  data: {
    WALLET: 'Wallet transaction history',
    EXPORT: 'Export',
    EXPORT_CSV: 'Export as CSV',
    EXPORT_XLS: 'Export as XLS',
    DATA: 'Date',
    REASON: 'Reason',
    INVOICE_ID: 'Invoice ID',
    TYPE: 'Type',
    DEBT_AMOUNT: 'Debt amount (-)',
    CREDIT_AMOUNT: 'Credit amount (+)',
    CLOSE: 'Close',
  },
};
